/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [emoji-navigation.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 05.10.18 13:31
 */

import React, {Fragment, useState} from 'react';
import {useAuthorization} from "../../selectors";
import LikeNavigation from "../like/like-navigation";
import EditPostDialog from "../dialogs/post/edit-post-dialog";
import DeletePostDialog from "../dialogs/post/delete-post-dialog";
import SharePostDialog from "../dialogs/post/share-post-dialog";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import usePostFileUploader from "../hooks/use-post-file-uploader";
import {SpinnerBig} from "../util/spinner";
import {RoundedButton} from "../navigation/buttons/nav-buttons";
import {Delete, EditRounded, Share} from "@material-ui/icons";
import {useLanguage} from "../configuration/configuration";
import {MessageRegularIcon, MessageSolidIcon} from "../navigation/icons/nav-icons";
import {useDispatch} from "react-redux";
import {notifyToggleComments} from "../../actions";

const PostNavigation = ({postId, post, spacename, configuration}) => {
    const [isShareOpen, setIsShareOpen] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const {isAuthorized, isSuperUser, principalUsername} = useAuthorization();
    const {uploadFiles, uploadVideo, status} = usePostFileUploader();
    const dispatch = useDispatch();
    const Lang = useLanguage();

    const handleTextAreaEnter = (text, files, embedded) => {
        if (embedded.length > 0) {
            uploadVideo(spacename, text, embedded);
        } else {
            uploadFiles(post, spacename, text, files);
        }
    }

    const handleOnShareOpen = (event) => {
        event.preventDefault();
        setIsShareOpen(true);
    }

    const handleOnEditOpen = (event) => {
        event.preventDefault();
        setIsEditOpen(true);
    }

    const handleOnDeleteOpen = (event) => {
        event.preventDefault();
        setIsDeleteOpen(true);
    }

    const handleOnToggle = event => {
        event.preventDefault();
        dispatch(notifyToggleComments('toggle', true, postId))
    }

    const isEditable = principalUsername === post.user.username;
    const isOwner = principalUsername === post.space.user.username;
    const isShared = post.state === 'SHARED';
    const allowLikes = isAuthorized || (configuration && configuration.public.likes === true);
    if (status === 'pending') return <SpinnerBig className='my-2'/>

    return <div className="post-navigation">
        <NavigationRow className='navigation-row-top'>
            {isAuthorized && allowLikes ? <NavigationGroup>
                <LikeNavigation postId={postId}/>
            </NavigationGroup> : <NavigationGroup/>}

            {isAuthorized &&
                <NavigationGroup>
                    <RoundedButton className='position-relative' title={Lang.post.comments.tooltip}
                                   onClick={handleOnToggle}>
                        {(!post.commentCount || post.commentCount === 0) ? <MessageRegularIcon/> :
                            <Fragment>
                                <MessageSolidIcon/>
                                <div className='badged-count-icon'>{post.commentCount}</div>
                            </Fragment>}
                    </RoundedButton>

                    <RoundedButton title={Lang.nav.like.share.tooltip} onClick={handleOnShareOpen}>
                        <Share fontSize='small'/>
                    </RoundedButton>
                    {(isEditable || isSuperUser) && !isShared &&
                        <RoundedButton title={Lang.nav.like.edit.tooltip} onClick={handleOnEditOpen}>
                            <EditRounded fontSize='small'/>
                        </RoundedButton>
                    }
                    {(isEditable || isOwner || isSuperUser) &&
                        // <DeletePostDialog post={post}/>
                        <RoundedButton title={Lang.nav.like.delete.tooltip} onClick={handleOnDeleteOpen}>
                        <Delete fontSize='small'/>
                        </RoundedButton>
                    }
                </NavigationGroup>}
        </NavigationRow>

        {isShareOpen && <SharePostDialog postId={postId} setOpen={setIsShareOpen}/>}
        {isEditOpen && <EditPostDialog post={post} setOpen={setIsEditOpen} callback={handleTextAreaEnter}/>}
        {isDeleteOpen && <DeletePostDialog post={post} setOpen={setIsDeleteOpen}/>}

        <div className="update-box-marker" id={`update-box-${postId}`}/>
    </div>
}

export default PostNavigation;